/** Decode stored name text, never HTML. Keep the server twin fixture-equivalent. */
export function decodeHtmlEntities(value: string): string {
  if (!value.includes('&')) return value;
  const named: Record<string, string> = { quot: '"', apos: "'", amp: '&', lt: '<', gt: '>' };
  let previous: string;
  do {
    previous = value;
    value = value.replace(/&(?:quot|apos|amp|lt|gt|#\d+|#x[\da-f]+);/gi, (entity) => {
      const body = entity.slice(1, -1);
      if (body[0] !== '#') return named[body] ?? entity;
      const hex = body[1].toLowerCase() === 'x';
      const point = Number.parseInt(body.slice(hex ? 2 : 1), hex ? 16 : 10);
      return point <= 0x10ffff && !(point >= 0xd800 && point <= 0xdfff)
        ? String.fromCodePoint(point) : entity;
    });
  } while (value !== previous && value.includes('&'));
  return value;
}
